// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyD8aB5v8CvoDj_0HZiR8D4ghqzsvtnjAto',
    authDomain: 'adsvlog-admin.firebaseapp.com',
    databaseURL: 'https://adsvlog-admin.firebaseio.com',
    projectId: 'adsvlog-admin',
    storageBucket: 'adsvlog-admin.appspot.com',
    messagingSenderId: '483362673691',
    appId: '1:483362673691:web:2b9bf1b812f3b4e3ca14be'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
